import LegalTaskFinished from '@/common/containers/Modals/LegalTaskFinished/LegalTaskFinished';

export default LegalTaskFinished;
